var rollbackWorkerDays = new Array(2);
export default {
  set: function set(index, value) {
    rollbackWorkerDays[index] = value;
  },
  get: function get(index) {
    return rollbackWorkerDays[index];
  },
  purge: function purge() {
    delete rollbackWorkerDays[0];
    delete rollbackWorkerDays[1];
  }
  /*
  delete (index) {
    console.warn('deleted')
    delete rollbackWorkerDays[index]
  }
  */

};